export class OnlineCalcModel {
    public id: number;
    public comm_plan_id: number;
    public adjustment_close_dt: Date;
    public dispute_close_dt: Date;
    public calc_close_flag: string;
    public comment: string;
    public created_dt: Date;
    public updated_dt: Date;
    public created_by: string;
    public updated_by: string;
    public salesChannel: string;
    public calRunId: string;
    public calendarType: string;
    public commPlan: string;
    public comids: string;
    public ids: string;
    public editMode: boolean;
    public loggedinUser: string;
    public adjust_close_dt: any;
    public disp_close_dt: any;
    constructor() {
        this.id = null;
        this.comm_plan_id = null;
        this.adjustment_close_dt = null;
        this.dispute_close_dt = null;
        this.calc_close_flag = null;
        this.comment = null;
        this.created_dt = null;
        this.updated_dt = null;
        this.created_by = null;
        this.updated_by = null;
        this.salesChannel = null;
        this.calRunId = null;
        this.calendarType = null;
        this.commPlan = null;
        this.comids = null;
        this.ids = null;
        this.editMode = null;
        this.loggedinUser = null;
        this.adjust_close_dt = null;
        this.disp_close_dt = null;
    }
}
